import { createStore } from '@ngneat/elf';
import { withEntities, selectAllEntities, setEntities, addEntities, updateEntities, deleteEntities } from '@ngneat/elf-entities';
import { SourceArchivial } from '../core/models';



export const store = createStore({ name: 'sourceArc' }, withEntities<SourceArchivial>());

export const sourceArc$ = store.pipe(selectAllEntities());

export function setSourceArc(sourceArc: SourceArchivial[]) {
  store.update(setEntities(sourceArc));
}

export function addSourceArc(sourceArc: SourceArchivial) {
  store.update(addEntities(sourceArc));
}

export function updateSourceArc(id: SourceArchivial['id'], sourceArc: Partial<SourceArchivial>) {
  store.update(updateEntities(id, sourceArc));
}

export function deleteSourceArc(id: SourceArchivial['id']) {
  store.update(deleteEntities(id));
}
